"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHandset = function SvgHandset(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M18.614.505c.756.674 1.23 1.099 1.424 1.274 1.076.957 1.25 2.312.52 4.063-1.091 2.628-5.188 8.963-14.11 14.318-1.97 1.385-3.738 1.073-4.55 0-.541-.715-1.072-1.4-1.592-2.055-.578-.892-.335-1.72.73-2.484 1.595-1.145 1.085-.741 2.39-1.635 1.303-.894 1.292-.694 3.022 0 1.729.694 1.746 1.3 3.459-.337 1.142-1.09 2.606-2.58 4.391-4.47.67-.629.67-1.414 0-2.355-1.004-1.41-1.004-1.953 0-3.499a29.29 29.29 0 0 1 2.068-2.82c.744-.673 1.493-.673 2.25 0z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHandset);
var _default = exports["default"] = Memo;